import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-scan-control-panel',
  templateUrl: './scan-control-panel.component.html',
  styleUrls: ['./scan-control-panel.component.css']
})
export class ScanControlPanelComponent {
  @Input() serialInput: string = '';
  @Input() isPeripheralMode: boolean = false;
  @Input() useInternalCode: boolean = false;

  @Output() serialInputChange = new EventEmitter<string>();
  @Output() isPeripheralModeChange = new EventEmitter<boolean>();
  @Output() useInternalCodeChange = new EventEmitter<boolean>();
  
  @Output() submitSerial = new EventEmitter<void>();
  @Output() togglePeripheral = new EventEmitter<void>();
  @Output() downloadTemplate = new EventEmitter<void>();
  @Output() importExcel = new EventEmitter<void>();

  onSerialSubmit() {
    this.submitSerial.emit();
  }

  onSerialInput(value: string) {
    this.serialInput = value;
    this.serialInputChange.emit(value);
  }

  onPeripheralModeToggle(value: boolean) {
    this.isPeripheralMode = value;
    this.isPeripheralModeChange.emit(value);
    this.togglePeripheral.emit();
  }

  onInternalCodeToggle(value: boolean) {
    this.useInternalCode = value;
    this.useInternalCodeChange.emit(value);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-scan/components/scan-control-panel/scan-control-panel.component.ts